import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';

const DefaultSection = ({ sectionResource: resource }) => {
  return (
    <MetaFormInline resource={resource} readonly />
  );
};

DefaultSection.defaultProps = {};

DefaultSection.propTypes = {
  sectionResource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { DefaultSection };
